"use client";

import {
	type DefaultImageProps,
	type DefaultLinkProps,
	Heading,
	RichText
} from "@pamperedchef/design-system";
import { className } from "@/app/utilities/className";
import type { HeadingTag, SeasonTheme } from "@/app/utilities/types";

import * as styles from "./EvergreenOffering.module.scss";
import {
	EvergreenOfferingCard,
	EvergreenOfferingCardProps
} from "./EvergreenOfferingCard";

export interface EvergreenOfferingProps<
	ImageComponentProps = DefaultImageProps,
	LinkComponentProps = DefaultLinkProps
> {
	headline?: string;
	headlineTag?: HeadingTag;
	description?: string;
	items?: EvergreenOfferingCardProps<
		ImageComponentProps,
		LinkComponentProps
	>[];
	theme: SeasonTheme;
}

/**
 * EvergreenOffering Component
 * @returns
 */
export function EvergreenOffering<
	ImageComponentProps = DefaultImageProps,
	LinkComponentProps = DefaultLinkProps
>({
	headline,
	headlineTag = "h1",
	description,
	items = [],
	theme = "standard"
}: EvergreenOfferingProps<
	ImageComponentProps,
	LinkComponentProps
>): JSX.Element {
	return (
		<div
			{...className(
				styles["evergreen-offering"],
				theme && styles[`evergreen-offering--${theme}`]
			)}
		>
			<div className="container">
				<div className={styles["evergreen-offering__heading"]}>
					<Heading styledAs="h1" tag={headlineTag}>
						{headline}
					</Heading>

					<RichText
						className={styles["evergreen-offering__subheading"]}
						content={description || ""}
					/>
				</div>

				<div className={styles["evergreen-offering__items"]}>
					{items?.map((item) => (
						<EvergreenOfferingCard
							key={item.headline}
							{...item}
							theme={theme}
						/>
					))}
				</div>
			</div>
		</div>
	);
}
